import React from 'react'

import Paper from 'components/Paper'
import Currency from 'components/Currency'
import T from 'components/FormattedMessage'

import { withStyles, createStyles, WithStyles, Typography, Grid, Theme } from '@material-ui/core'

import { IMatch, GamePrizeInfoResponse } from 'protos'

import ResponsiveJerseyFrame from './components/ResponsiveJerseyFrame'
import EntryFeePicker from './components/EntryFeePicker'
import TopChoice from './components/TopChoice'

interface Props {
  feeOptions: Array<GamePrizeInfoResponse.IFeeOption>
  selectedFeeIndex: number
  setSelectedFeeIndex: (index: number) => void
  balance: number
  isBalanceSufficient: boolean
  selectedMatch: IMatch
}

const styles = (theme: Theme) => createStyles({
  balanceContainer: {
    marginTop: theme.spacing() * 4,
    marginBottom: theme.spacing() * 4,
    paddingTop: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 2,
    paddingLeft: theme.spacing() * 3,
    paddingRight: theme.spacing() * 3,
    borderRadius: 4,
  },
  titleContainer: {
    marginTop: theme.spacing(),
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
  },
  topChoiceContainer: {
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
    margin: '0 auto',
    maxWidth: 600,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const SelectStake: React.SFC<InjectedProps> = ({
  classes,
  balance,
  feeOptions,
  selectedFeeIndex,
  isBalanceSufficient,
  setSelectedFeeIndex,
  selectedMatch: { homeTeam, awayTeam },
}) => (
  <>
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <ResponsiveJerseyFrame
          homeJersey={homeTeam && homeTeam.jersey}
          awayJersey={awayTeam && awayTeam.jersey}
        >
          <Grid container justify="center">
            <Grid item className={classes.titleContainer}>
              <Typography variant="h4" align="center">
                <T id="gameconfirmation_prompt" />
              </Typography>
            </Grid>
            <Grid item>
              <Paper color={isBalanceSufficient ? 'accent' : 'error'} className={classes.balanceContainer}>
                <Typography variant="caption" color="inherit">
                  <T id="common_text_balance" /> <Currency value={balance} />
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </ResponsiveJerseyFrame>
      </Grid>
      <Grid item>
        <EntryFeePicker
          feeOptions={feeOptions}
          onChange={setSelectedFeeIndex}
          selectedIndex={selectedFeeIndex}
          isBalanceSufficient={isBalanceSufficient}
        />
      </Grid>
    </Grid>
    <div className={classes.topChoiceContainer}>
      <TopChoice feeOption={feeOptions[selectedFeeIndex]} />
    </div>
  </>
)

export default withStyles(styles)(SelectStake)
